import { format, setDay } from "date-fns"
import type { UserEvent } from "@/services/api/cronos/user/events/get-all"

export default function getEventFrequency(event: UserEvent): string {
  const days = event.parent.days

  // 0 days of frequency.
  if (days.length === 0) {
    return ""
  }

  // 7 days of frequency.
  if (days.length === 7) {
    return "Todos los días"
  }

  const sortedDays = [...days].sort((a, b) => {
    const adjustedA = a === 0 ? 7 : a
    const adjustedB = b === 0 ? 7 : b
    return adjustedA - adjustedB
  })

  const dayNames = sortedDays.map((day) => {
    return format(setDay(new Date(), day, { weekStartsOn: 1 }), "cccc")
  })

  // 1 day of frequency.
  if (dayNames.length === 1) {
    return dayNames[0]
  }

  // 2 days of frequency.
  if (dayNames.length === 2) {
    return `${dayNames[0]} y ${dayNames[1]}`
  }

  const isConsecutive = (() => {
    const adjustedDays = sortedDays.map((day) => (day === 0 ? 7 : day))

    for (let i = 0; i < adjustedDays.length - 1; i++) {
      if (adjustedDays[i + 1] - adjustedDays[i] !== 1) {
        return false
      }
    }
    return true
  })()

  // 3 or more consecutive days of frequency.
  if (isConsecutive) {
    return `${dayNames[0]} a ${dayNames[dayNames.length - 1]}`
  }

  // 3 or more non-consecutive days of frequency.
  const lastDay = dayNames.pop()
  return `${dayNames.join(", ")} y ${lastDay}`
}
